var cartAction = "empty";
var bundleNumber = 0;
const customBundleFooter = document.querySelector('[data-custom-bundle-footer]');
const normalText = customBundleFooter.dataset.normalText;
const maxText = customBundleFooter.dataset.maxText;
const maxNumber = customBundleFooter.dataset.maxNumber;
const bundleNumberSelector = document.querySelector('[data-bundle-current-number]');
const bundleText = document.querySelector('[data-bundle-text]');
const btnCheckout = document.querySelector('[data-bundle-checkout]');
const loadingElement = document.querySelector('[data-loading-gif]');
const loadingIcon = loadingElement.querySelector('img');
const addToCartBtns = document.querySelectorAll('.custom-bundle-atc');
const btnScrollTop = document.getElementById("btn_scroll_top");

btnScrollTop.addEventListener("click", () => {
  $('html, body').animate({
    scrollTop: 0
  }, 500);
});

const goToCheckout = () => {
  location.href = '/checkout';
}

const bundleFooterControlFunc = () => {
  bundleNumberSelector.textContent = bundleNumber;
  
  if (bundleNumber >= Number(maxNumber)) {
    bundleText.textContent = maxText;
    btnCheckout.classList.add('reached');
    btnCheckout.removeAttribute('disabled');
    
    if (addToCartBtns.length > 0) {
      addToCartBtns.forEach(btn => {
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('disabled');
      })
    }

  } else {
    bundleText.textContent = normalText;
    btnCheckout.classList.remove('reached');
    btnCheckout.setAttribute('disabled', 'disabled');

    if (addToCartBtns.length > 0) {
      addToCartBtns.forEach(btn => {
        btn.removeAttribute('disabled');
        btn.classList.remove('disabled');
      })
    }
  }
}

const bundleCheckFunc = () => {
  jQuery.getJSON('/cart.js', function(cart) {
    let bundleNum = 0;
    
    if(cart.items.length > 0) {
      cart.items.forEach(item => {
        if (item.product_type == "Underwear") {
          bundleNum += item.quantity;
        }
      });
    }

    bundleNumber = bundleNum;

    bundleFooterControlFunc();
  })
}

document.addEventListener("DOMContentLoaded", function(event) {
  bundleCheckFunc();
})